import { render, staticRenderFns } from "./scAudio.vue?vue&type=template&id=ef5183a6&scoped=true&"
import script from "./scAudio.vue?vue&type=script&lang=js&"
export * from "./scAudio.vue?vue&type=script&lang=js&"
import style0 from "./scAudio.vue?vue&type=style&index=0&id=ef5183a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5183a6",
  null
  
)

export default component.exports